import React from "react";

import {
  List,
  Datagrid,
  TextField,
  Button,
  EditButton,
  ShowButton,
  DeleteWithConfirmButton,
  FunctionField,
  useDataProvider,
  useRefresh,
  useNotify,
} from "react-admin";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import DoDisturbOffIcon from "@mui/icons-material/DoDisturbOff";
import { EmptyList } from "common/components";
import { CreateActions } from "utils/customActions";
const ISHIDDEN = "visibility";

const ListProjects = () => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  return (
    <List actions={<CreateActions />}>
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Име на проекта"
          source="title"
          sortable={false}
        />
        <FunctionField
          label=""
          render={record =>
            `${record.is_hidden}` === "true" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOffIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Покажи"
                  onClick={() => {
                    return dataProvider
                      .customRequest(`projects/${record.id}/${ISHIDDEN}`, { id: record.id, is_hidden: false }, "PUT")
                      .then(() => {
                        refresh();
                        notify("Проектите са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        notify("Проектите не са обновени!", { type: "error" });
                        refresh();
                      });
                  }}
                />
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOnIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Скрий"
                  color="error"
                  onClick={() => {
                    return dataProvider
                      .customRequest(`projects/${record.id}/${ISHIDDEN}`, { id: record.id, is_hidden: true }, "PUT")
                      .then(() => {
                        refresh();
                        notify("Проектите са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        notify("Проектите не са обновени!", { type: "error" });
                        refresh();
                      });
                  }}
                />
              </div>
            )
          }
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListProjects;
